import { useState, useRef } from "react";

import { API_URL, getValFromLS } from "../helpers";

import Msg from "../components/Msg";
import Submit from "../components/Submit";

const StatusesGolfForm1 = ({ success, data }) => {
	const [msg, setMsg] = useState({});
	const formElement = useRef(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/dashboardStatusesGolf`);
		let formData = new FormData(formElement.current);
		formData.append("auth", getValFromLS("dash", true));
		formData.append("fromAdmin", getValFromLS("vtoUserToken") ? "1" : "0");

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				success(json.text);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			style={{ marginTop: "0" }}
		>
			<table className="approved assigned">
				<thead>
					<tr>
						<th colSpan="3" className="hdg">
							Golf Groups Course Assignments
						</th>
					</tr>
					<tr className={data.groups[0] === "0" ? "hidden" : ""}>
						<td className="center">Group</td>
						<td className="center" style={{ width: "45%" }}>
							Preferred Course(s)
						</td>
						<td className="center" style={{ width: "45%" }}>
							Assigned Course
						</td>
					</tr>
				</thead>
				{data.guests.length > 0 ? (
					<tbody>
						{data.groups.map((group) => {
							return (
								<tr key={group}>
									<td className="center">
										<span>{group}</span>
									</td>
									<td className="center">
										<select
											name={`groupNumber[${group}]`}
											className="form-control"
											placeholder=""
											autoComplete="off"
											style={{
												display: "inline-block",
												paddingLeft: "5px",
												width: "250px",
											}}
											defaultValue={getDefault(
												data.groupsCourses,
												group,
												"courseId"
											)}
										>
											{data.courses.map((course) => {
												return (
													<option key={course.id} value={course.id}>
														{course.name}
													</option>
												);
											})}
										</select>

										<select
											name={`groupNumber2[${group}]`}
											className="form-control"
											placeholder=""
											autoComplete="off"
											style={{
												display: "inline-block",
												paddingLeft: "5px",
												width: "250px",
												marginTop: "10px",
												marginBottom: "10px",
											}}
											defaultValue={getDefault(
												data.groupsCourses,
												group,
												"courseId2"
											)}
										>
											{data.courses.map((course) => {
												return (
													<option key={course.id} value={course.id}>
														{course.name}
													</option>
												);
											})}
										</select>

										<select
											name={`groupNumber3[${group}]`}
											className="form-control"
											placeholder=""
											autoComplete="off"
											style={{
												display: "inline-block",
												paddingLeft: "5px",
												width: "250px",
											}}
											defaultValue={getDefault(
												data.groupsCourses,
												group,
												"courseId3"
											)}
										>
											{data.courses.map((course) => {
												return (
													<option key={course.id} value={course.id}>
														{course.name}
													</option>
												);
											})}
										</select>
									</td>
									<td className="center">
										{getAssigned(data.groupsCourses, group)}
									</td>
								</tr>
							);
						})}
					</tbody>
				) : (
					<tbody>
						<tr>
							<td
								className="center"
								colSpan="4"
								style={{ paddingTop: "15px", paddingBottom: "15px" }}
							>
								<span className="working">
									{data.groups[0] === "0"
										? " -- Not participating in this event --"
										: " -- No guests statuses found --"}
								</span>
							</td>
						</tr>
					</tbody>
				)}
			</table>

			{data.groups.length > 0 && (
				<div className="msg-submit">
					{msg.type && <Msg data={msg} />}

					<div
						className={
							msg.type === "working" || msg.type === "success"
								? "hidden"
								: "submit-container"
						}
					>
						<Submit submit="Update Group Course Assignments" />
					</div>
				</div>
			)}
		</form>
	);
};

export default StatusesGolfForm1;

function getDefault(array, group, preference) {
	let courseId = "0";
	array.forEach((item) => {
		if (item.group === group) {
			courseId = item[preference]; // courseId, courseId2, courseId3
		}
	});

	return courseId;
}

function getAssigned(array, group) {
	let courseName = "";
	array.forEach((item) => {
		if (item.group === group) {
			courseName = item.courseName;
		}
	});

	return courseName;
}
